import React from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import panelStyles from '../panelStyles';
import {formatMoney} from '../panelMetrics';

/**
 * Bugunun operasyonel ozeti: bes ayri kart, ikon kutusu solda.
 * Panelin geri kalani donem analizi; bu satir "su an ne oluyor".
 * Ikon rengi anlami tasir ama tek basina tasimaz: etiket her zaman yaninda.
 */
export default function NowTiles({today, movements, revenue, cancelledToday, pendingToday}) {
    const {t} = useTranslation();
    const classes = panelStyles();

    const tile = (icon, tone, label, value, sub) => (
        <div className={classes.tile}>
            <span className={`${classes.tileIcon} ${classes[tone]}`}>
                <i className={icon} />
            </span>
            <div className={classes.tileBody}>
                <div className={classes.tileLabel}>{label}</div>
                <div className={classes.tileValue}>{value}</div>
                {sub && <div className={classes.tileSub}>{sub}</div>}
            </div>
        </div>
    );

    const money = revenue && revenue.code
        ? <>{formatMoney(revenue.amount)}<small>{revenue.code}</small></>
        : '—';

    return (
        <div className={classes.tiles}>
            {tile('fas fa-sign-in-alt', 'toneIn', t('enw-panel-today_checkin', 'Bugün giriş'), movements.checkIn)}
            {tile('fas fa-sign-out-alt', 'toneOut', t('enw-panel-today_checkout', 'Bugün çıkış'), movements.checkOut)}
            {tile('fas fa-plus', 'toneNew', t('enw-panel-today_new', 'Yeni rezervasyon'), today.length)}
            {tile(
                'fas fa-lira-sign',
                'toneMoney',
                // Tarih parantez icinde: rakamin hangi gune ait oldugu tek bakista belli olsun
                t('enw-panel-today_revenue', {
                    defaultValue: 'Günlük ciro ({{date}})',
                    date: moment().format('D MMMM'),
                }),
                money,
                // Ciro on rezervasyonu icermez; adetle ciro tutmayinca sebebini yaz
                [
                    revenue && revenue.others && revenue.others.length
                        ? revenue.others.map((o) => `+ ${formatMoney(o.amount)} ${o.code}`).join(' · ')
                        : null,
                    pendingToday > 0
                        ? t('enw-panel-pending_excluded', {
                            defaultValue: '{{count}} ön rezervasyon hariç',
                            count: pendingToday,
                        })
                        : null,
                ].filter(Boolean).join(' · ') || null
            )}
            {tile(
                'fas fa-times',
                'toneCancel',
                t('enw-panel-today_cancelled', 'Bugün iptal'),
                cancelledToday.count,
                cancelledToday.revenue && cancelledToday.revenue.code
                    ? `−${formatMoney(cancelledToday.revenue.amount)} ${cancelledToday.revenue.code}`
                    : null
            )}
        </div>
    );
}
